var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99982 6.75017V9.75017M8.99982 12.7502H9.00732M7.9613 2.91897L1.79264 13.5739C1.45049 14.1649 1.27941 14.4604 1.30469 14.7029C1.32675 14.9145 1.43758 15.1067 1.60959 15.2318C1.80681 15.3752 2.14826 15.3752 2.83115 15.3752H15.1685C15.8514 15.3752 16.1928 15.3752 16.39 15.2318C16.5621 15.1067 16.6729 14.9145 16.6949 14.7029C16.7202 14.4604 16.5491 14.1649 16.207 13.5739L10.0383 2.91896C9.6974 2.33009 9.52694 2.03566 9.30454 1.93677C9.11055 1.85051 8.88908 1.85051 8.69509 1.93677C8.47269 2.03566 8.30223 2.33009 7.9613 2.91897Z",
    stroke: "#E73751",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertImg);
export default __webpack_public_path__ + "static/media/alertImg.0c75e8f0a18547c36f43da05f41f47dd.svg";
export { ForwardRef as ReactComponent };